export const getQueryParam = (queryString, paramName, defaultValue = '') => {
  let query = queryString.replace('?', '')
  const keyValuePairs = query.split('&')
  const params = {}
  keyValuePairs.forEach(keyValue => {
    const [key, value] = keyValue.split('=')
    params[key] = decodeURIComponent(value)
  })
  return params[paramName] || defaultValue
}

export const slugify = (str) => {

}
